/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import { FileInput, FileField, SaveButton, required } from 'react-admin';
import { Form } from 'react-final-form';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';

const validateFile = [required()];

const ThumbnailDialogEdit = (props) => {
  const handleClose = () => {
    props.close();
  };

  const handleClick = () => {
    document
      .querySelector('#preview-quick-create')
      .dispatchEvent(new Event('submit', { cancelable: true }));
  };

  const handleSubmit = (Thumbnail) => {
    Thumbnail.url = Thumbnail.file.url;

    props.onValidated(Thumbnail);
    handleClose();
  };

  return (
    <Dialog
      size="large"
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Edit thumbnail</DialogTitle>
      <DialogContent>
        <Form onSubmit={handleSubmit} initialValues={props.record}>
          {({ handleSubmit, values }) => (
            <form
              id="preview-quick-create"
              toolbar={null}
              record={values}
              onSubmit={handleSubmit}
            >
              <FileInput
                label="Thumbnail Image"
                source="file"
                placeholder={<p>Drop your thumbnail file here</p>}
                validate={validateFile}
              >
                <FileField source="url" title="title" target="_blank" />
              </FileInput>
            </form>
          )}
        </Form>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={handleClose}>
          Cancel
        </Button>
        <SaveButton
          size="small"
          color="primary"
          handleSubmitWithRedirect={handleClick}
          label="Add preview"
        >
          Submit
        </SaveButton>
      </DialogActions>
    </Dialog>
  );
};

export default ThumbnailDialogEdit;
